export default "__VITE_ASSET__5ddb9196__"